import React, { Component } from 'react';
import './items.css';

import Item from "./item.js";
import ChartMilestones from "./charts/milestones.js"

class Items extends Component {
	constructor(props) {
		super(props);
		this.load = this.load.bind( this );
		this.getStats = this.getStats.bind( this );
		
		this.state = {
			"articles": [],
			"current_page": 0,
			"next_page": -1,
			"prev_page": -1,
			"slug": null,
			"name":null,
			"short_name":null,
			"path": null,
			"stats": null
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.Location !== this.props.Location ) {
			this.load();
		}
	}
	
	getStats( slug ) {
		slug = slug.split('/')[0];
		var location = this.props.BaseUrl + this.props.StatsUrl + '/' + slug;
		this.props.FetchContent(
			location,
			{},
			(data) => {
				if ( !data.error ) {
					this.setState( { "stats": data.stats } );
				} else {
					console.log( data.errormessage );
				}
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	load() {
		var location = null,
			slug = false;
		
		if ( this.props.Location ) {
			if ( this.props.Location === '#/' ) {
				slug = '';
				location = false; // this.props.BaseUrl + this.props.BrowseUrl;
			} else if ( this.props.Location.indexOf('/categoria/') > -1 ) {
				slug = this.props.Location.replace(/#\/categoria\//ig,'');
				location = this.props.BaseUrl + this.props.BrowseUrl + '/' + slug;
			} else if ( this.props.Location.indexOf('/filtra/') > -1 ) {
				location = this.props.BaseUrl + this.props.FilterUrl + '/' + this.props.Location.replace(/#\/filtra\//ig,'');
			} else if ( this.props.Location.indexOf('/temi') > -1 ) {
				location = this.props.BaseUrl + this.props.TopicsUrl + '/' + this.props.Location.replace(/temi\//ig,'temi').replace(/#\/temi/ig,'');
			}
		}
		
		if ( location ) {
			this.props.FetchContent(
				location,
				{},
				(data) => {
					if ( data.error ) {
						console.log( data.errormessage );
						window.location.hash = '/leggi/errore';
					} else {
						this.setState( { "articles": data.articles } );
						if ( data.function === 'browse' || data.function === 'topics' ) {
							if ( data.collection && data.collection.name ) {
								this.props.SetTitle( data.collection.name );
								this.setState(
									{
										"current_page": data.page,
										"prev_page": ( data.page > 0 ) ? data.page - 1 : -1,
										"next_page": ( data.page < ( data.total_pages - 1) ) ? data.page + 1 : -1,
										"slug": data.collection.slug,
										"name": data.collection.name,
										"short_name": data.collection.short_name,
										"path": 'categoria',
										"stats": null
									}, 
									() => { 
										this.props.ShowLoading( false );
										this.getStats( slug );
									}
								);
							} else if (data.function === 'topics') {
								this.props.SetTitle( 'Temi' );
								this.setState(
									{
										"current_page": data.page,
										"prev_page": ( data.page > 0 ) ? data.page - 1 : -1,
										"next_page": ( data.page < ( data.total_pages - 1) ) ? data.page + 1 : -1,
										"slug": null,
										"name": null,
										"short_name": null,
										"path": 'temi',
										"stats": null
									},
									() => { 
										this.props.ShowLoading( false );
									}
								);
								
								
							} else {
								this.props.SetTitle( '' );
								this.setState(
									{
										"current_page": 0,
										"prev_page": -1,
										"next_page": -1,
										"slug": null,
										"name":null,
										"short_name":null,
										"path": null,
										"stats": null
									},
									() => { 
										this.props.ShowLoading( false );
										this.getStats( slug );
									}
								);
							}
						} else if ( data.function === 'search' ) {
							if ( data.keyword ) {
								this.props.SetTitle( '#' + data.keyword );
							}
							this.setState(
								{
									"current_page": data.page,
									"prev_page": ( data.page > 0 ) ? data.page - 1 : -1,
									"next_page": ( data.page < ( data.total_pages - 1) ) ? data.page + 1 : -1,
									"slug": escape( data.keyword ),
									"path": 'filtra',
									"name":null,
									"short_name":null,
									"stats": null
								},
								() => {
									this.props.ShowLoading( false );
									this.getStats('');
								}	
							);
						
						}
					}
				},
				(error) => {
					console.log( error );
					window.location.hash = '/leggi/errore';
				}
			);
		}
	}
	
	render() {
		var filtered, stats, slug, name, short_name, fetchContent, popularity_url, base_url;
		if ( this.state.slug === null || this.state.path === 'filtra' ) {
			filtered = false;
		} else {
			filtered = true;	
		}
		stats = this.state.stats;
		slug = this.state.slug;
		name = this.state.name;
		fetchContent = this.props.FetchContent;
		short_name = this.state.short_name;
		popularity_url = this.props.PopularityUrl;
		base_url = this.props.BaseUrl;
		
		if ( this.state.articles.length > 0 ) {
			return (
				<div className="items-wrapper">
					<ItemsCoverage Path={this.state.path} Collection={name} CollectionSlug={slug} FetchContent={this.props.FetchContent} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} />
					<ol className="items">
						{
							this.state.articles.map(
								function(article, index) {
									return <Item key={article.id + '-' + index} Article={article} Filtered={filtered} Stats={stats} Slug={slug} Name={name} ShortName={short_name} FetchContent={fetchContent} PopularityUrl={popularity_url} BaseUrl={base_url}></Item>
								}
							)
						}
					</ol>
					<Pagination CurrentPage={this.state.current_page} PrevPage={this.state.prev_page} NextPage={this.state.next_page} Slug={this.state.slug} Path={this.state.path} />
				</div>
			);
		} else {
			return (
				<div className="items-wrapper">
					<ol className="items">
						<li className="article message">
							<article>
								<header>
									<h1>Nessun risultato :(</h1>
								</header>
								<p>Ci spiace, non siamo stati in grado di trovare alcun articolo su "<b>{this.state.slug}</b>".</p>
								<p>Puoi provare ad effettuare una nuova ricerca, oppure ripartire da una delle nostre categorie: <a href="#/categoria/centro-destra">Centro Destra</a>, <a href="#/categoria/centro-sinistra">Centro Sinistra</a>, <a href="#/categoria/m5s">Movimento 5 Stelle</a>, <a href="#/categoria/sinistra">Sinistra</a>, <a href="#/categoria/destra">Destra</a> che rappresentano i maggiori schieramenti presenti alle elezioni del 4 marzo 2018.</p>
								<p>Se cerchi qualche suggerimento per le ricerche, al temine di ogni articolo sono presenti dei <i>tag</i> generati automaticamente che attivano le funzionalità di ricerca.</p>
							</article>	
						</li>
					</ol>
				</div>
			);
		}
	}
}

export default Items;

class Pagination extends Component {
  render() {
    let prev = ( this.props.PrevPage > -1 ) ? true : false;
    let next =  ( this.props.NextPage > -1 ) ? true : false;
    if ( this.props.Slug ) {
	    return	<div className="pagination-wrapper"><ul className="pagination">
	    			{ prev && <li className="pagination-prev"><a href={"#/" + this.props.Path + "/" + this.props.Slug + ( ( this.props.PrevPage > 0 ) ? "/" + this.props.PrevPage : "" )}>Precedente</a></li> }
	    			{ next && <li className="pagination-next"><a href={"#/" + this.props.Path + "/" + this.props.Slug + "/" + this.props.NextPage}>Successivo</a></li> }
	    		</ul></div>
    } else {
	    return null;
    }
  }
}


class ItemsCoverage extends Component {
	render() {
		if (this.props.Path === 'categoria') {
			return (
				 
					<div className="items-coverage">
						<ChartMilestones ChartId="coverage-over-time" Collection={this.props.Collection} CollectionSlug={this.props.CollectionSlug} FetchContent={this.props.FetchContent} BaseUrl={this.props.BaseUrl}  VizUrl={this.props.VizUrl} AnimationDuration={this.props.AnimationDuration} AddLabel="true" />
					</div>
			)
		} else {
			return null
		}
	}
}



// WEBPACK FOOTER //
// ./src/Elezioni/items.js